import {
  IListingToProspectiveTenant,
  ITransferTenantDetails,
  IGroupOccupantMapping,
  IConfirmedAppfolioAssignment,
} from "../Models";
import { baseUrl, getTokenFromLocalStorage } from "./Configuration";

interface EmailData {
  keypairOfToAndSuject: Array<{ email: string; subject: string }>;
  cc: string[];
  body: string;
}
export async function fetchProspectiveTenantsForAppointment(
  appointmentID: string,
) {
  const response = await fetch(
    baseUrl +
      "/api/Showings/GetProspectiveTenantsForAppointment/" +
      appointmentID,
    {
      headers: {
        Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
      },
    },
  );
  if (response.status === 401) {
    localStorage.clear();
    window.location.href = "/login";
    return;
  }
  if (response.status === 204) {
    return [];
  }
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }
  const text = await response.text();
  return text ? JSON.parse(text) : [];
}

export async function sendEmailToTenants(emailData: EmailData) {
  const url = baseUrl + "/api/Showings/SendEmailToTenants";
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(emailData),
    });
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error("Failed to send Email");
    }
    return await response.json();
  } catch (error: any) {
    throw new Error(`Error: ${error.message}`);
  }
}

export async function AddNote(Note: string | null, tenantId: string) {
  const url = baseUrl + "/api/Showings/addNote/" + tenantId;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };

  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify({ Note: Note }),
    });
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error("Failed to add note");
    }
  } catch (error: any) {
    throw new Error(`Error: ${error.message}`);
  }
}

export async function DeleteListingToProspectiveTenants(
  data: IListingToProspectiveTenant[],
) {
  const url = baseUrl + "/api/Showings/DeleteListingToProspectiveTenant";
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };

  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(data),
    });
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error("Failed to Delete ListingToProspectiveTenants");
    }
  } catch (error: any) {
    throw new Error(`Error: ${error.message}`);
  }
}

export async function TransferTenantToAppartmentService(
  data: ITransferTenantDetails[],
) {
  const url = baseUrl + "/api/Showings/TransferTenant";
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    });
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error("Failed to Transfer Tenant To Appartment");
    }
  } catch (error: any) {
    throw new Error(`Error: ${error.message}`);
  }
}

export async function GetMemberAndGuarntor(arhId: string) {
  const url = baseUrl + `/api/Reminder/GetMemberAndGuarntor/${arhId}`;
  const headers = {
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };

  try {
    const response = await fetch(url, {
      headers: headers,
    });
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (response.status === 204) {
      return [];
    }
    if (!response.ok) {
      throw new Error("Failed to fetch MemberandGaurantor details");
    }
    const text = await response.text();
    return text ? JSON.parse(text) : [];
  } catch (error: any) {
    throw new Error(`Error: ${error.message}`);
  }
}

export async function RemoveMemberAndGuarntor(id: string) {
  const url = baseUrl + `/api/Reminder/DeleteMemberAndGuarntor/${id}`;
  const headers = {
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };

  try {
    const response = await fetch(url, {
      headers: headers,
      method: "DELETE",
    });
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error("Failed to delete MemberandGaurantor details");
    }
  } catch (error: any) {
    throw new Error(`Error: ${error.message}`);
  }
}

export async function SaveMemberAndGuarntor(
  arhId: string,
  data: { id: string; name: string; email: string; isGuarantor: boolean }[],
) {
  const url = `${baseUrl}/api/Reminder/SaveMemberAndGuarntor?arhId=${arhId}`;

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };

  try {
    var modifiedData: {
      id: string;
      arhId: string;
      name: string;
      email: string;
      isGuarantor: boolean;
    }[] = [];

    data.forEach((e) => {
      modifiedData.push({
        id: e.id.includes("-") ? e.id : "00000000-0000-0000-0000-000000000000",
        arhId: arhId,
        name: e.name,
        email: e.email,
        isGuarantor: e.isGuarantor,
      });
    });
    const response = await fetch(url, {
      headers: headers,
      method: "POST",
      body: JSON.stringify(modifiedData),
    });

    if (!response.ok) {
      throw new Error("Failed to Transfer Tenant To Appartment");
    }
  } catch (error: any) {
    throw new Error(`Error: ${error.message}`);
  }
}

export async function fetchPaymentAndBidInfo(
  arhId: string,
  fetchAll: boolean = false,
) {
  const url =
    baseUrl +
    `/api/Reminder/GetPaymentAndBidInfo/${arhId}?fetchAll=${fetchAll}`;
  const headers = {
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };
  try {
    console.log("🔵 API CALL: fetchPaymentAndBidInfo");
    console.log(`  URL: ${url}`);

    const response = await fetch(url, {
      headers: headers,
    });

    console.log(`  HTTP Status: ${response.status}`);

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return [];
    }

    // Check if response is OK
    if (!response.ok) {
      console.warn(
        `  API returned status ${response.status}, returning empty array`,
      );
      return [];
    }

    // Check if response has content
    const text = await response.text();
    if (!text) {
      console.warn(`  API returned empty response, returning empty array`);
      return [];
    }

    const data = JSON.parse(text);
    console.log(`  Response data:`, data);
    console.log(`  Items count: ${Array.isArray(data) ? data.length : 0}`);

    return data;
  } catch (error: any) {
    console.error("❌ Error in fetchPaymentAndBidInfo:", error);
    return []; // Return empty array instead of throwing
  }
}

export async function fetchVenmoSuggestedMembers(arhId: string) {
  const url = baseUrl + `/api/Reminder/GetVenmoSuggestedMembers/${arhId}`;
  const headers = {
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };
  try {
    const response = await fetch(url, { headers: headers });

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return { matched: false };
    }

    if (!response.ok) {
      return { matched: false };
    }

    const text = await response.text();
    if (!text) {
      return { matched: false };
    }

    return JSON.parse(text);
  } catch (error: any) {
    console.error("❌ Error in fetchVenmoSuggestedMembers:", error);
    return { matched: false };
  }
}

export async function fetchAppfolioSuggestedMembers(arhId: string) {
  const url = baseUrl + `/api/Reminder/GetAppfolioSuggestedMembers/${arhId}`;
  const headers = {
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };
  try {
    const response = await fetch(url, { headers: headers });

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return { matched: false };
    }

    if (!response.ok) {
      return { matched: false };
    }

    const text = await response.text();
    if (!text) {
      return { matched: false };
    }

    return JSON.parse(text);
  } catch (error: any) {
    console.error("❌ Error in fetchAppfolioSuggestedMembers:", error);
    return { matched: false };
  }
}

export async function fetchVenmoPaymentSummary(arhId: string) {
  const url = baseUrl + `/api/Reminder/GetVenmoPaymentSummary/${arhId}`;
  const headers = {
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };
  try {
    const response = await fetch(url, { headers: headers });

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return { payments: [] };
    }

    if (!response.ok) {
      return { payments: [] };
    }

    const text = await response.text();
    if (!text) {
      return { payments: [] };
    }

    return JSON.parse(text);
  } catch (error: any) {
    console.error("❌ Error in fetchVenmoPaymentSummary:", error);
    return { payments: [] };
  }
}

export async function fetchVenmoCandidates(arhId: string) {
  const url = baseUrl + `/api/Reminder/GetVenmoCandidates/${arhId}`;
  const headers = {
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };
  try {
    const response = await fetch(url, { headers: headers });

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return [];
    }

    if (!response.ok) {
      return [];
    }

    const text = await response.text();
    if (!text) {
      return [];
    }

    return JSON.parse(text);
  } catch (error: any) {
    console.error("❌ Error in fetchVenmoCandidates:", error);
    return [];
  }
}

// Source-2 candidates (group-aware AppFolio scrape) for the listing tied to an ARH,
// mirroring fetchVenmoCandidates' shape/error-handling for the "AppFolio" matching panel.
export async function fetchGroupOccupantsForArh(
  arhId: string,
): Promise<IGroupOccupantMapping[]> {
  const url = baseUrl + `/api/Reminder/GetGroupOccupantsForArh/${arhId}`;
  const headers = {
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };
  try {
    const response = await fetch(url, { headers: headers });

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return [];
    }

    if (!response.ok) {
      return [];
    }

    const text = await response.text();
    if (!text) {
      return [];
    }

    return JSON.parse(text);
  } catch (error: any) {
    console.error("❌ Error in fetchGroupOccupantsForArh:", error);
    return [];
  }
}

// Every currently-confirmed AppFolio assignment, system-wide (both Source 1 and
// Source 2) — fetched once and used by the matching screens to exclude a
// lead/occupant from a group's candidate list once it's already confirmed to a
// member of a different group. See GetConfirmedAppfolioAssignments.
export async function fetchConfirmedAppfolioAssignments(): Promise<
  IConfirmedAppfolioAssignment[]
> {
  const url = baseUrl + `/api/Reminder/GetConfirmedAppfolioAssignments`;
  const headers = {
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };
  try {
    const response = await fetch(url, { headers: headers });

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return [];
    }

    if (!response.ok) {
      return [];
    }

    const text = await response.text();
    if (!text) {
      return [];
    }

    return JSON.parse(text);
  } catch (error: any) {
    console.error("❌ Error in fetchConfirmedAppfolioAssignments:", error);
    return [];
  }
}

export async function saveVenmoMemberMappings(
  arhId: string,
  mappings: { memberId: string; venmoKey: string | null }[],
) {
  const url = baseUrl + `/api/Reminder/SaveVenmoMemberMappings`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };
  const response = await fetch(url, {
    headers: headers,
    method: "POST",
    body: JSON.stringify({
      arhId: arhId,
      mappings: mappings.map((m) => ({
        memberId: m.memberId,
        venmoKey: m.venmoKey,
      })),
    }),
  });
  if (response.status === 401) {
    localStorage.clear();
    window.location.href = "/login";
    return;
  }
  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(text || "Failed to Save Venmo Member Mappings");
  }
}

// Unresolved PublicApplicationGroups whose occupant names fuzzy-match a member of this
// specific ARH's roster — mirrors fetchVenmoCandidates' unresolved-pool shape.
export async function fetchUnresolvedAppfolioGroupSuggestions(arhId: string) {
  const url =
    baseUrl + `/api/Reminder/GetUnresolvedAppfolioGroupSuggestions/${arhId}`;
  const headers = {
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };
  try {
    const response = await fetch(url, { headers: headers });

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return [];
    }

    if (!response.ok) {
      return [];
    }

    const text = await response.text();
    if (!text) {
      return [];
    }

    return JSON.parse(text);
  } catch (error: any) {
    console.error("❌ Error in fetchUnresolvedAppfolioGroupSuggestions:", error);
    return [];
  }
}

// Manually pins an unresolved PublicApplicationGroup to this ARH's listing.
export async function linkUnresolvedAppfolioGroup(
  groupId: string,
  arhId: string,
) {
  const url = baseUrl + `/api/Reminder/LinkUnresolvedAppfolioGroup`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };
  const response = await fetch(url, {
    headers: headers,
    method: "POST",
    body: JSON.stringify({ groupId: groupId, arhId: arhId }),
  });
  if (response.status === 401) {
    localStorage.clear();
    window.location.href = "/login";
    return;
  }
  if (!response.ok) {
    throw new Error("Failed to link AppFolio group");
  }
}

export async function savePaymentAndBidInfo(info: any) {
  const url = baseUrl + `/api/Reminder/SavePaymentAndBidInfo`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };
  const response = await fetch(url, {
    headers: headers,
    method: "POST",
    body: JSON.stringify(info),
  });
  if (response.status === 401) {
    localStorage.clear();
    window.location.href = "/login";
    return;
  }
  if (!response.ok) {
    throw new Error("Failed to Save PaymentAndBillinfo");
  }
}

export async function GetAllMemberAndGuarantor(
  arhId: string,
  getAllForProperty: boolean,
) {
  const url =
    baseUrl +
    `/api/Reminder/GetMemberAndGuarantor/${arhId}/${getAllForProperty}`;
  const headers = {
    Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
  };

  try {
    console.log("🔵 API CALL: GetAllMemberAndGuarantor");
    console.log(`  URL: ${url}`);
    console.log(`  arhId: ${arhId}, getAllForProperty: ${getAllForProperty}`);

    const response = await fetch(url, {
      headers: headers,
    });

    console.log(`  HTTP Status: ${response.status}`);

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (response.status === 204) {
      console.log("  API returned 204 No Content, returning empty array");
      return [];
    }
    if (!response.ok) {
      throw new Error("Failed to fetch member and guarantor data");
    }

    const text = await response.text();
    const data = text ? JSON.parse(text) : [];
    console.log(`  Response data:`, data);
    console.log(`  Items count: ${Array.isArray(data) ? data.length : 0}`);

    return data;
  } catch (error: any) {
    console.error("❌ Error in GetAllMemberAndGuarantor:", error);
    throw new Error(`Error: ${error.message}`);
  }
}
